import React, { createContext, useContext, useState, useEffect } from 'react';
import T from '../i18n/translations';

const LangContext = createContext();

const RTL_LANGS = ['ar', 'fa'];

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('sc_lang') || 'ar');
  const t = T[lang] || T['ar'];
  const dir = RTL_LANGS.includes(lang) ? 'rtl' : 'ltr';

  const setLang = (newLang) => {
    if (!['ar', 'fa', 'en'].includes(newLang)) return;
    localStorage.setItem('sc_lang', newLang);
    setLangState(newLang);
  };

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir  = dir;
  }, [lang, dir]);

  return (
    <LangContext.Provider value={{ lang, setLang, t, dir }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}

export default LangContext;
